import { API_URL } from "../config/connect";

/**
 * Fetches all active promotion packages from the backend
 * @returns {Promise<Array>} Array of promotion packages
 */
export async function getPromotionPackages() {
    try {
        const endpoint = `${API_URL}/api/v1/promotion-packages`;

        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({ detail: response.statusText }));
            throw new Error(`Error: ${response.status} - ${errorData.detail || response.statusText}`);
        }

        const data = await response.json();
        return data.packages || [];
    } catch (error) {
        console.error('Failed to get promotion packages:', error);
        throw error;
    }
}




